(function(){
'use strict';

var PRODUCT_HANDLE='carls-place-diy-enclosure';

var ACCESSORIES=[
  {handle:'pipe-framing-kit',label:'Pipe Framing Kit',description:'Everything you need to build the frame for your enclosure. Includes all pipes cut to length.',sizeVariants:{'7.7x10':{price:389.95},'7.7x13':{price:414.95},'8x8':{price:349.95},'8x10.5':{price:394.95},'8.5x11.5':{price:404.95},'9x12':{price:414.95}}},
  {handle:'foam-insert-kit',label:'Foam Insert Kit',description:'Foam inserts that fill the enclosure side channels for a cleaner, more finished look.',sizeVariants:{'7.7x10':{price:135.00},'7.7x13':{price:145.00},'8x8':{price:150.00},'8x10.5':{price:160.00},'8.5x11.5':{price:170.00},'9x12':{price:180.00}}},
  {handle:'safety-baffle',label:'Safety Baffle',description:'Adds an extra layer of protection behind the impact screen to reduce ball bounce-back.',flat:true,sizeVariants:{'7.7x10':{price:40.00},'7.7x13':{price:40.00},'8x8':{price:40.00},'8x10.5':{price:40.00},'8.5x11.5':{price:40.00},'9x12':{price:40.00}}},
  {handle:'back-cover-kit',label:'Back Cover Kit',description:'Covers the back of the enclosure for a clean, professional look from behind.',sizeVariants:{'7.7x10':{price:215.00},'7.7x13':{price:235.00},'8x8':{price:235.00},'8x10.5':{price:255.00},'8.5x11.5':{price:265.00},'9x12':{price:275.00}}},
  {handle:'back-cover-pipe-kit',label:'Back Cover Pipe Kit',description:'Pipes needed to mount the back cover kit to your enclosure frame.',sizeVariants:{'7.7x10':{price:140.00},'7.7x13':{price:150.00},'8x8':{price:155.00},'8x10.5':{price:165.00},'8.5x11.5':{price:170.00},'9x12':{price:180.00}}}
];

var SIZES=['7.7x10','7.7x13','8x8','8x10.5','8.5x11.5','9x12'];
var MATERIALS=['Standard Golf Impact','Preferred Golf Impact','Premium Golf Impact','High-Contrast Gray Premium'];
var state={material:null,size:null,accessories:{},productData:null};

function fmt(n){return '$'+parseFloat(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}

function getVariantPrice(material,size){
  if(!state.productData)return 0;
  var v=state.productData.variants.find(function(vv){return vv.options[0]===material&&vv.options[1]===size;});
  return v?parseFloat(v.price)/100:0;
}

function getVariantId(material,size){
  if(!state.productData)return null;
  var v=state.productData.variants.find(function(vv){return vv.options[0]===material&&vv.options[1]===size;});
  return v?v.id:null;
}

function totalPrice(){
  var base=state.material&&state.size?getVariantPrice(state.material,state.size):0;
  var acc=0;
  Object.keys(state.accessories).forEach(function(h){
    var qty=state.accessories[h]||0;
    if(qty>0){
      var a=ACCESSORIES.find(function(x){return x.handle===h;});
      if(a&&state.size&&a.sizeVariants[state.size])acc+=qty*a.sizeVariants[state.size].price;
    }
  });
  return base+acc;
}

function buildCSS(){
  var style=document.createElement('style');
  style.textContent=[
    '.sng-enc-wrap{font-family:inherit;margin:0}',
    '.sng-enc-section{margin-bottom:22px}',
    '.sng-enc-section-head{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:10px}',
    '.sng-enc-section-label{font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#555}',
    '.sng-enc-section-helper{font-size:12px;color:#368ADD;cursor:pointer;text-decoration:underline}',
    '.sng-mat-select{width:100%;padding:11px 14px;border:1px solid #d0d5dd;border-radius:8px;font-size:13px;font-weight:600;color:#333;background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath d=\'M2 4l4 4 4-4\' stroke=\'%23555\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E") no-repeat right 14px center;-webkit-appearance:none;appearance:none;cursor:pointer;transition:border-color .15s}',
    '.sng-mat-select:focus{outline:none;border-color:#368ADD;box-shadow:0 0 0 2px rgba(54,138,221,.15)}',
    '.sng-size-btns{display:flex;flex-wrap:wrap;gap:8px}',
    '.sng-size-btn{padding:10px 18px;border:1px solid #d0d5dd;border-radius:8px;background:#fff;color:#333;font-size:13px;font-weight:600;cursor:pointer;transition:all .15s;min-width:72px;text-align:center}',
    '.sng-size-btn:hover{border-color:#368ADD;color:#368ADD}',
    '.sng-size-btn.active{border-color:#368ADD;background:#f0f6ff;color:#368ADD;box-shadow:0 0 0 1px #368ADD}',
    '.sng-cascade{display:none;animation:sngSlideIn .25s ease}',
    '.sng-cascade.visible{display:block}',
    '@keyframes sngSlideIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}',
    '.sng-acc-list{display:grid;gap:10px}',
    '.sng-acc-row{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;gap:12px}',
    '.sng-acc-info{flex:1;min-width:0}',
    '.sng-acc-name{font-size:13px;font-weight:600;color:#111;margin-bottom:2px}',
    '.sng-acc-desc{font-size:11px;color:#888;line-height:1.4}',
    '.sng-acc-price{font-size:13px;font-weight:700;color:#111;white-space:nowrap;min-width:60px;text-align:right}',
    '.sng-qty{display:flex;align-items:center;border:1px solid #d0d5dd;border-radius:6px;overflow:hidden;flex-shrink:0}',
    '.sng-qty-btn{width:32px;height:32px;background:#f5f5f5;border:none;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#555;transition:background .15s}',
    '.sng-qty-btn:hover{background:#e5e5e5}',
    '.sng-qty-val{width:32px;text-align:center;font-size:13px;font-weight:600;color:#111;border:none;background:#fff;padding:0;height:32px;line-height:32px}',
    '.sng-price-row{display:flex;align-items:baseline;gap:10px;margin:16px 0 4px}',
    '.sng-price-now{font-size:28px;font-weight:900;color:#111}',
    '.sng-add-btn{width:100%;padding:16px;background:#368ADD;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:background .2s;margin-top:8px}',
    '.sng-add-btn:hover{background:#2a6ab8}',
    '.sng-add-btn:disabled{background:#ccc;cursor:not-allowed}',
    '.sng-custom-size-btn{display:flex;align-items:center;gap:8px;padding:10px 18px;border:1px solid #d0d5dd;border-radius:8px;background:#fff;color:#555;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s;text-decoration:none;margin-top:10px}',
    '.sng-custom-size-btn:hover{border-color:#368ADD;color:#368ADD}',
    '.sng-divider{border:none;border-top:1px solid #f0f0f0;margin:20px 0}'
  ].join('');
  document.head.appendChild(style);
}

function buildHTML(container){
  container.innerHTML=[
    '<div class="sng-enc-wrap">',
    '<div class="sng-price-row"><span class="sng-price-now" id="sng-price-display">As low as $999.95</span></div>',
    '<hr class="sng-divider">',
    '<div class="sng-enc-section">',
    '<div class="sng-enc-section-head"><span class="sng-enc-section-label">Screen Material <span style="color:#e53e3e">*</span></span><span class="sng-enc-section-helper">How do I know?</span></div>',
    '<select class="sng-mat-select" id="sng-mat-select"><option value="">Choose an Option...</option>',
    MATERIALS.map(function(m){return '<option value="'+m+'">'+m+'</option>';}).join(''),
    '</select></div>',
    '<div class="sng-cascade" id="sng-size-section">',
    '<div class="sng-enc-section">',
    '<div class="sng-enc-section-head"><span class="sng-enc-section-label">Enclosure Size <span style="color:#e53e3e">*</span></span><span class="sng-enc-section-helper">Check size details</span></div>',
    '<div class="sng-size-btns">',
    SIZES.map(function(s){return '<button class="sng-size-btn" data-size="'+s+'">'+s+'</button>';}).join(''),
    '</div>',
    '</div></div>',
    '<div class="sng-cascade" id="sng-acc-section">',
    '<div class="sng-enc-section">',
    '<div class="sng-enc-section-head"><span class="sng-enc-section-label">Accessories</span><span class="sng-enc-section-helper">A little help here?</span></div>',
    '<div class="sng-acc-list" id="sng-acc-list"></div>',
    '</div></div>',
    '<button class="sng-add-btn" id="sng-add-btn" disabled>Select options above to continue</button>',
    '</div>'
  ].join('');
}

function renderAccessories(){
  var list=document.getElementById('sng-acc-list');
  if(!list||!state.size)return;
  list.innerHTML=ACCESSORIES.map(function(a){
    var sv=a.sizeVariants[state.size];
    var price=sv?sv.price:0;
    var qty=state.accessories[a.handle]||0;
    return[
      '<div class="sng-acc-row" data-acc="'+a.handle+'">',
      '<div class="sng-acc-info"><div class="sng-acc-name">'+a.label+(a.flat?'':' ('+state.size+')')+'</div>',
      '<div class="sng-acc-desc">'+a.description+'</div></div>',
      '<div class="sng-acc-price">'+fmt(price)+'</div>',
      '<div class="sng-qty">',
      '<button class="sng-qty-btn" data-acc="'+a.handle+'" data-dir="-1">&#8722;</button>',
      '<span class="sng-qty-val" id="qty-'+a.handle+'">'+qty+'</span>',
      '<button class="sng-qty-btn" data-acc="'+a.handle+'" data-dir="1">+</button>',
      '</div></div>'
    ].join('');
  }).join('');
  list.querySelectorAll('.sng-qty-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var h=btn.dataset.acc;
      var dir=parseInt(btn.dataset.dir);
      state.accessories[h]=Math.max(0,(state.accessories[h]||0)+dir);
      document.getElementById('qty-'+h).textContent=state.accessories[h];
      updatePrice();
    });
  });
}

function updatePrice(){
  var el=document.getElementById('sng-price-display');
  if(!el)return;
  if(!state.material){el.textContent='As low as $999.95';return;}
  if(state.material&&!state.size){
    var minPrice=Math.min.apply(null,SIZES.map(function(s){return getVariantPrice(state.material,s)||9999;}));
    el.textContent='As low as '+fmt(minPrice);return;
  }
  el.textContent=fmt(totalPrice());
}

function updateAddBtn(){
  var btn=document.getElementById('sng-add-btn');
  if(!btn)return;
  if(state.material&&state.size){btn.disabled=false;btn.textContent='Add to Cart';}
  else if(state.material){btn.disabled=true;btn.textContent='Select an enclosure size';}
  else{btn.disabled=true;btn.textContent='Select options above to continue';}
}

function updateImage(){
  var variantId=getVariantId(state.material,state.size);
  if(!variantId||!state.productData)return;
  var v=state.productData.variants.find(function(vv){return vv.id===variantId;});
  if(!v||!v.featured_image)return;
  var newSrc=v.featured_image.src;
  var imgs=document.querySelectorAll('.product-main-slide-container img, [main-slider] img, product-carousel img');
  imgs.forEach(function(img){
    img.src=newSrc;
    img.setAttribute('src',newSrc);
    if(img.srcset)img.srcset='';
    if(img.dataset&&img.dataset.src)img.dataset.src=newSrc;
  });
}

function addToCart(){
  var variantId=getVariantId(state.material,state.size);
  if(!variantId)return;
  var items=[{id:variantId,quantity:1}];
  var btn=document.getElementById('sng-add-btn');
  btn.disabled=true;btn.textContent='Adding...';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(function(r){return r.json();})
  .then(function(){
    btn.textContent='Added!';btn.style.background='#1a7a3f';
    setTimeout(function(){
      btn.disabled=false;btn.textContent='Add to Cart';btn.style.background='';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var cartIcon=document.querySelector('[data-cart-toggle], .cart-icon-btn, [href="/cart"]');
      if(cartIcon)cartIcon.click();
    },1500);
  })
  .catch(function(){btn.disabled=false;btn.textContent='Add to Cart';});
}

function init(){
  if(!window.location.pathname.includes(PRODUCT_HANDLE))return;
  buildCSS();
  fetch('/products/'+PRODUCT_HANDLE+'.js')
  .then(function(r){return r.json();})
  .then(function(data){
    state.productData=data;
    var mount=document.getElementById('sng-enclosure-selector-mount');
    if(!mount)return;
    buildHTML(mount);
    var matSelect=document.getElementById('sng-mat-select');
    matSelect&&matSelect.addEventListener('change',function(){
      state.material=matSelect.value||null;
      state.size=null;state.accessories={};
      document.querySelectorAll('.sng-size-btn').forEach(function(b){b.classList.remove('active');});
      var sizeSection=document.getElementById('sng-size-section');
      var accSection=document.getElementById('sng-acc-section');
      if(state.material){sizeSection&&sizeSection.classList.add('visible');}
      else{sizeSection&&sizeSection.classList.remove('visible');accSection&&accSection.classList.remove('visible');}
      updatePrice();updateAddBtn();updateImage();
    });
    document.querySelectorAll('.sng-size-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        state.size=btn.dataset.size;
        document.querySelectorAll('.sng-size-btn').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var accSection=document.getElementById('sng-acc-section');
        if(accSection){accSection.classList.add('visible');renderAccessories();}
        updatePrice();updateAddBtn();updateImage();
      });
    });
    var addBtn=document.getElementById('sng-add-btn');
    addBtn&&addBtn.addEventListener('click',function(){if(!addBtn.disabled)addToCart();});
  })
  .catch(function(e){console.warn('SNG Enclosure Selector error',e);});
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

})();